enum CampaignContextOperation {
    Delete,
    Rename,
    Duplicate,
}

export default CampaignContextOperation;
